// extracted by mini-css-extract-plugin
module.exports = {"bigSlider":"BigSlider_bigSlider__2WN39","image":"BigSlider_image__2TPWc","content":"BigSlider_content__3hLiU","text":"BigSlider_text__2QNEI","buttons":"BigSlider_buttons__1un8E"};